import { Injectable, computed, inject } from '@angular/core';
import { MobileAppLinksService } from '@core/auth/services/mobile-app-links.service';
import { PlatformUtilityService } from '@shared/services/platform/platform-utility.service';

@Injectable({
  providedIn: 'root'
})
export class AppPromoService {
  private readonly mobileAppLinksService = inject(MobileAppLinksService);
  private readonly platformUtility = inject(PlatformUtilityService);

  readonly isPromoEligible = computed(() => {
    if (!this.platformUtility.isWebPlatform()) {
      return false;
    }

    const links = this.mobileAppLinksService.getMobileAppLinks();
    if (!links) {
      return false;
    }

    return links.appStore.isActive || links.playStore.isActive;
  });
  openAppStoreLink(): void {
    const url = this.mobileAppLinksService.getMobileAppLinks()?.appStore.url;
    if (url) {
      this.platformUtility.openExternalUrl(url);
    }
  }

  openPlayStoreLink(): void {
    const url = this.mobileAppLinksService.getMobileAppLinks()?.playStore.url;
    if (url) {
      this.platformUtility.openExternalUrl(url);
    }
  }
}
